import React from "react";
import ChangePassword from "./views/ChangePassword";
import { ChangePasswordContextProvider } from "./ChangePasswordView";

const ChangePasswordPage = () => {
  return (
    <div>
      <ChangePasswordContextProvider >
        <ChangePassword />
      </ChangePasswordContextProvider>
    </div>
  );
};

export default ChangePasswordPage;
